import React, { useEffect } from "react";

import "./App.css";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Upload from "./pages/upload/index";
import { HashRouter as Router } from "react-router-dom";
import Vonsole from "vconsole";
function App() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      import("vconsole").then((VConsole) => {
        new VConsole.default();
      });
    }

    return () => {
      new Vonsole().destroy();
    };
  }, []);
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
function AppContent() {
  const location = useLocation();
  const is404 =
    location.pathname !== "/upload" && location.pathname !== "/successed";
  console.log(location, is404);
  return (
    <div className="App">
      <Routes>
        {/* <Route path="/" element={<Upload />} /> */}
        {/* <Route path="/" element={<Navigate replace to="/upload" />} /> */}
        <Route path="/" element={<Upload />} />
        {/* <Route path="/successed" element={<Succeed />} /> */}
      </Routes>
      {/* {!is404&&<Footer/>} */}
    </div>
  );
}

export default App;
